import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { ChevronDown } from "lucide-react";

export default function StatusFilter() {
    const { filterStatus, setFilterStatus } = useRulesContext();

    return (
        <div className="relative">
            <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="w-full sm:w-auto max-w-none appearance-none bg-white border border-gray-200 rounded-lg px-4 py-2 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                <option value="all">
                    {__(
                        "All Status",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                </option>
                <option value="active">
                    {__("Active", "wpbean-quantity-controls-for-woocommerce")}
                </option>
                <option value="inactive">
                    {__("Inactive", "wpbean-quantity-controls-for-woocommerce")}
                </option>
                <option value="trash">
                    {__("Trash", "wpbean-quantity-controls-for-woocommerce")}
                </option>
            </select>
            <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
        </div>
    );
}
